import { createAuthService } from '@tourmalinecore/react-tc-auth';

import { API_ROOT } from '../config/config';

export const authService = createAuthService({
  authApiRoot: `${API_ROOT}/auth`,
  authType: 'ls',
  tokenAccessor: 'accessToken',
  tokenValueAccessor: 'value',
  tokenExpireAccessor: 'expiresInUtc',
});
